import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import { getAccessToken, getRefreshToken } from "../hooks/user.actions";

const axiosService = axios.create({
    baseURL: "https://beatsapi.ilemlembo.me/api/",
    /* headers: {
        'Content-Type': 'multipart/form-data',
    }, */
    headers: {
        "Content-Type" : "application/json"
    }
});

axiosService.interceptors.request.use(async (config)=>{
    /*
        Retrieving the access_token from the LocalStorage
        and adding it to the headers of our request 
    */

    const access = getAccessToken()
    config.headers.Authorization = `Bearer ${access}`;

    return config;

});

axiosService.interceptors.response.use(
    (res) => Promise.resolve(res),
    (err) => Promise.reject(err),
);

const refreshAuthLogic = async (failedRequest) => {
    return axios.post("/auth/refresh/", { "refresh" : getRefreshToken() }, {
        baseURL: "https://beatsapi.ilemlembo.me/api/",
        headers: {
            Authorization: `Bearer ${getRefreshToken()}`,
        },
    })
    .then((resp) => {
        const { access, refresh, user } = resp.data;
        failedRequest.response.config.headers["Authorization"] = "Bearer " + access;
            /* localStorage.setItem("access", JSON.stringify({
                access,
                refresh,
                user
            })); */
            localStorage.setItem("access", access)
    })
    .catch(()=> {
        localStorage.removeItem("auth");
    });
};

createAuthRefreshInterceptor(axiosService, refreshAuthLogic);

export function fetcher(url){
    return axiosService.get(url).then((res) => res.data);
}

export default axiosService;